import api from "./axios";

export const getPublicPage = (slug) => api.get(`/api/pages/${slug}/`);

// Admin
export const adminGetPages = () => api.get("/api/admin/pages/");
export const adminGetPage = (id) => api.get(`/api/admin/pages/${id}/`);
export const adminCreatePage = (data) => api.post("/api/admin/pages/", data);
export const adminUpdatePage = (id, data) => api.put(`/api/admin/pages/${id}/`, data);
export const adminDeletePage = (id) => api.delete(`/api/admin/pages/${id}/`);

// Page sections
export const adminGetPageSections = () => api.get("/api/admin/page-sections/");
export const adminCreatePageSection = (data) => api.post("/api/admin/page-sections/", data);